//get Trailer
export const GET_TRAILER = "GET_TRAILER";

//Insert Trailer
export const INSERT_TRAILER = "INSERT_TRAILER";

//Update Trailer
export const UPDATE_TRAILER = "UPDATE_TRAILER";

//Delete Trailer
export const DELETE_TRAILER = "DELETE_TRAILER";

//Open and Close Dialog
export const OPEN_TRAILER_DIALOG = "OPEN_TRAILER_DIALOG";
export const CLOSE_TRAILER_DIALOG = "CLOSE_TRAILER_DIALOG";

//toast
export const OPEN_TRAILER_TOAST = "OPEN_TRAILER_TOAST";
export const CLOSE_TRAILER_TOAST = "CLOSE_TRAILER_TOAST";
